// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1KcAL","row":"ProcedureTreatmentSummary_row__2qIWM"};